<template>
  <layout-card-wrap
    v-loading="loading"
    hasSlot>
    <template slot="title">类目数据</template>
    <div v-loading="loading">
      <summary-list
        v-for="(item,index) in list"
        :key="index"
        :list="item"
        :span="4" />
    </div>
  </layout-card-wrap>
</template>

<script>
import SummaryList from '@/pages/home/summary.vue'
import Ai from '@/service/ai'
export default {
  name: 'OverviewData',
  components: { SummaryList },
  props: {
    option: { type: Object, default() { return {} } }
  },
  data() {
    return { loading: false, list: [] }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    splitListIntoChunks(list, count) {
      const chunks = []
      for (let i = 0; i < list.length; i += count) {
        chunks.push(list.slice(i, i + count))
      }
      return chunks
    },
    fetchList() {
      this.loading = true
      Ai.getinventorysbycategory({ ...this.option })
        .then(res => {
          this.loading = false
          const { result, message, data } = res.data
          if (result === 0) {
            const list = data.map(i => ({ label: i.categoryName, value: i.totalStockBalance }))
            this.list = this.splitListIntoChunks(list, 6)
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
